/**
 * Authority Add Offline Complaint View
 * Form for adding offline complaints
 */

import React from 'react';

const AddOfflineComplaintView = ({
  offlineComplaint = {
    name: '',
    mobile: '',
    email: '',
    address: '',
    complaint: '',
    documents: []
  },
  onComplaintChange,
  onFileUpload,
  onRemoveDocument,
  onClearForm,
  onSaveComplaint
}) => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-lg border border-gray-100">
        <div className="p-6 space-y-6">
          {/* User Information */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                Name *
              </label>
              <input
                type="text"
                id="name"
                value={offlineComplaint.name}
                onChange={(e) => onComplaintChange && onComplaintChange({ ...offlineComplaint, name: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-400 focus:border-primary-400"
                placeholder="Enter complainant name"
              />
            </div>
            <div>
              <label htmlFor="mobile" className="block text-sm font-medium text-gray-700 mb-2">
                Mobile Number *
              </label>
              <input
                type="tel"
                id="mobile"
                value={offlineComplaint.mobile}
                onChange={(e) => onComplaintChange && onComplaintChange({ ...offlineComplaint, mobile: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-400 focus:border-primary-400"
                placeholder="Enter mobile number"
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                value={offlineComplaint.email}
                onChange={(e) => onComplaintChange && onComplaintChange({ ...offlineComplaint, email: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-400 focus:border-primary-400"
                placeholder="Enter email address"
              />
            </div>
            <div>
              <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-2">
                Address
              </label>
              <input
                type="text"
                id="address"
                value={offlineComplaint.address}
                onChange={(e) => onComplaintChange && onComplaintChange({ ...offlineComplaint, address: e.target.value })}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-400 focus:border-primary-400"
                placeholder="Enter address"
              />
            </div>
          </div>

          {/* Complaint Message */}
          <div>
            <label htmlFor="complaint" className="block text-sm font-medium text-gray-700 mb-2">
              Complaint Message *
            </label>
            <textarea
              id="complaint"
              rows={6}
              value={offlineComplaint.complaint}
              onChange={(e) => onComplaintChange && onComplaintChange({ ...offlineComplaint, complaint: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-400 focus:border-primary-400"
              placeholder="Enter detailed complaint message..."
            />
          </div>

          {/* Document Upload */}
          <div>
            <label htmlFor="documents" className="block text-sm font-medium text-gray-700 mb-2">
              Supporting Documents
            </label>
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
              <input
                type="file"
                id="documents"
                multiple
                onChange={onFileUpload}
                className="hidden"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              />
              <label htmlFor="documents" className="cursor-pointer">
                <svg className="w-12 h-12 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                </svg>
                <p className="text-sm text-gray-600">Click to upload documents or drag and drop</p>
                <p className="text-xs text-gray-500 mt-1">PDF, DOC, DOCX, JPG, PNG files</p>
              </label>
            </div>
            
            {/* Uploaded Files */}
            {offlineComplaint.documents && offlineComplaint.documents.length > 0 && (
              <div className="mt-4">
                <h4 className="text-sm font-medium text-gray-700 mb-2">Uploaded Files:</h4>
                <div className="space-y-2">
                  {offlineComplaint.documents.map((doc, index) => (
                    <div key={index} className="flex items-center justify-between bg-gray-50 px-3 py-2 rounded-lg">
                      <span className="text-sm text-gray-700">{doc}</span>
                      <button
                        onClick={() => onRemoveDocument && onRemoveDocument(index)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
            <button
              onClick={onClearForm}
              className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors duration-200"
            >
              Clear Form
            </button>
            <button
              onClick={onSaveComplaint}
              className="px-6 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors duration-200"
            >
              Save Complaint
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOfflineComplaintView;

